// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';
import { Link } from 'components/Gui';
import { Color, flex, hover } from 'styles';

const Data = [
  {
    title: 'Regulatory',
    url: '/regulatory',
    links: [
      {
        title: 'Terms & Conditions',
        url: '/terms-and-conditions',
      },
      {
        title: 'Regulation and Safety of Funds',
        url: '/regulation-and-safety-of-funds',
      },
      {
        title: 'Privacy Policy',
        url: '/privacy-policy',
      },
      {
        title: 'AML Policy',
        url: '/aml-policy',
      },
      {
        title: 'Negative Balance Protection Policy',
        url: '/negative-balance-protection-policy',
      },
    ],
  },
  {
    title: 'Announcements',
    url: '/regulatory',
  },
  {
    title: 'Contact Us',
    url: '/contact-us',
  },
];

const OuterWrapper = styled.div`
  ${flex('space-between', 'flex-start')};
`;

const Wrapper = styled.div`
  ${flex('flex-start', 'flex-start')};
  flex-direction: column;
  width: 240px;
  flex: 0 0 auto;

  a {
    ${hover('color', Color.BLACK_SOUL, Color.MARKETS_RED)};

    font-weight: 400;
  }

  > div {
    margin-bottom: 10px;
    > a {
      font-weight: 700;
    }
    > div {
      ${flex('flex-start', 'flex-start')};
      flex-direction: column;

      a {
        text-indent: 10px;
        margin-top: 10px;
      }
    }
  }
`;

const LinksList = styled.div`
  margin-left: 40px;
  > div {
    h2 {
      margin: 12px 0 20px 0;
    }
    > div.links {
      ${flex('flex-start', 'flex-start')};
      flex-direction: column;

      a {
        ${hover('color', Color.MARKETS_RED, Color.BLACK_SOUL)};
        font-weight: 400;
        margin-bottom: 12px;
      }
    }
  }
`;

const ResourcesSideBar = ({
  sectionIndex,
  pageIndex,
  showLinksList = 99,
  children,
}: {
  sectionIndex: number,
  pageIndex?: number,
  showLinksList?: number,
  children?: Node,
}) => (
  <OuterWrapper>
    <Wrapper>
      {Data.map(({ title, url, links }, index) => (
        <div key={`ResourcesSideBar-${index}`}>
          <Link url={url}>{title}</Link>
          {links && sectionIndex === index && showLinksList === 99 && (
            <div>
              {links.map(({ title: innerTitle, url: innerUrl }, innerIndex) => (
                <Link key={`ResourcesSideBar-${index}-${innerIndex}`} url={innerUrl}>
                  {innerTitle}
                </Link>
              ))}
            </div>
          )}
        </div>
      ))}
    </Wrapper>
    <LinksList>
      <span>{`Resources > ${Data[sectionIndex].title}${
        typeof pageIndex !== 'undefined' ? ` > ${Data[sectionIndex].links[pageIndex].title}` : ''
      }`}</span>
      <div>
        <h2>{typeof pageIndex !== 'undefined' ? Data[sectionIndex].links[pageIndex].title : Data[sectionIndex].title}</h2>
        {showLinksList !== 99 && (
          <div className="links">
            {Data[sectionIndex].links.map(({ title: innerTitle, url: innerUrl }, index) => (
              <Link key={`ResourcesSideBarRight-${index}`} url={innerUrl}>
                {innerTitle}
              </Link>
            ))}
          </div>
        )}
        {children}
      </div>
    </LinksList>
  </OuterWrapper>
);

export default ResourcesSideBar;
